class ProductInfoTabs extends HTMLElement {
  #tabs = [];
  #panels = [];

  connectedCallback() {
    if (this.dataset.tabsReady === 'true') return;

    const accordion = this.querySelector('.accordion--tabs');
    const rows = accordion ? [...accordion.querySelectorAll(':scope > accordion-custom')] : [];
    if (!accordion || !rows.length) return;

    this.dataset.tabsReady = 'true';

    const tablist = document.createElement('div');
    tablist.className = 'product-tabs__tablist';
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-label', 'Product information');

    const panels = document.createElement('div');
    panels.className = 'product-tabs__panels';

    rows.forEach((row, index) => {
      const details = row.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      const panel = details?.querySelector(':scope > .details-content');
      if (!details || !summary || !panel) return;

      const tabId = `product-tab-${this.id || 'info'}-${index}`;
      const panelId = `product-panel-${this.id || 'info'}-${index}`;
      const tab = document.createElement('button');

      tab.type = 'button';
      tab.className = 'product-tabs__tab';
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      tab.textContent = summary.textContent.trim();

      panel.id = panelId;
      panel.classList.add('product-tabs__panel');
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabId);
      panel.hidden = index !== 0;

      row.setAttribute('open-by-default-on-mobile', '');
      row.setAttribute('open-by-default-on-desktop', '');
      details.open = true;

      tab.addEventListener('click', () => this.#activate(index));
      tab.addEventListener('keydown', this.#onKeyDown);

      this.#tabs.push(tab);
      this.#panels.push(panel);
      tablist.append(tab);
      panels.append(row);
    });

    accordion.replaceChildren(tablist, panels);
    this.addEventListener('shopify:block:select', this.#onBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('shopify:block:select', this.#onBlockSelect);
  }

  #activate(index, focus = false) {
    this.#tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      this.#panels[tabIndex].hidden = !selected;
    });

    if (focus) this.#tabs[index]?.focus();
  }

  #onKeyDown = (event) => {
    const current = this.#tabs.indexOf(event.currentTarget);
    let next = current;

    if (event.key === 'ArrowRight') next = (current + 1) % this.#tabs.length;
    else if (event.key === 'ArrowLeft') next = (current - 1 + this.#tabs.length) % this.#tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.#tabs.length - 1;
    else return;

    event.preventDefault();
    this.#activate(next, true);
  };

  #onBlockSelect = (event) => {
    const selectedRow = event.target.closest('accordion-custom');
    const index = [...this.querySelectorAll('.product-tabs__panels > accordion-custom')].indexOf(selectedRow);
    if (index >= 0) this.#activate(index);
  };
}

if (!customElements.get('product-info-tabs')) {
  customElements.define('product-info-tabs', ProductInfoTabs);
}
